import styled from 'styled-components'
import { Typography as MuiTypography } from '@material-ui/core'

export const Typography = styled(MuiTypography)`
  margin: 0;
`
